module.exports = __webpack_public_path__ + "static/media/teachersaid-teacher-template.adc57e25.xlsx";